import { SubSection } from '../../../report-pdf/components'

export { SubSection }
